import { render, staticRenderFns } from "./TripChanges.vue?vue&type=template&id=5ba6b13a&"
import script from "./TripChanges.vue?vue&type=script&lang=js&"
export * from "./TripChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports